import type { ColumnMeta } from "@tanstack/react-table";
import type { FilterType } from "./FilterType";

type ColumnFilter = ColumnMeta<unknown, unknown>["filter"];

export function hasCustomFilterComponent(
  filter: ColumnFilter,
): filter is Extract<
  NonNullable<ColumnFilter>,
  { component: React.JSXElementConstructor<unknown> }
> {
  return !!filter && "component" in filter && !!filter.component;
}

export function hasAllowedFilterTypes(
  filter: ColumnFilter,
): filter is Extract<
  NonNullable<ColumnFilter>,
  { allowedFilterTypes: FilterType[] }
> {
  return (
    !!filter && "allowedFilterTypes" in filter && !!filter.allowedFilterTypes
  );
}
